import { Box, Stack, Typography } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC, useEffect, useRef, useState } from 'react';
import CreateForm from '../../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import CreateTable from '../../../../../../../../components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import GetRecords from '../../../../../../../../lib/api/GetRecords';
import { APIS } from '../../../../../../../../lib/constants/apis';
import {
	ANTRAG_TYP,
	FORM_FIELDS_TYPES,
	KOSTEN_ARTEN,
	MAX_COLUMNS_HORIZONTAL_LAYOUT,
	PLATZHALTER_TEXT,
} from '../../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../../lib/types/types';
import {
	getFieldNamefromDataPath,
	getIDFromResponseOption,
	getOptionsFromRes,
	removeDataKeys,
	removeNullDeep,
} from '../../../../../../../../utils/helper';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import { find } from 'lodash';
import SparteSchema from '../../../../../../../../lib/paths/division_FULL_Paths.json';
import FoerderProgrammSchema from '../../../../../../../../lib/paths/foerderprogramm_FULL_Paths.json';
import NachweisPositionSchema from '../../../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import UnternehmenSchema from '../../../../../../../../lib/paths/unternehmen_FULL_Paths.json';
import VerwendungsNachweisSchema from '../../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsNachweisSchema.attributes;
const SP_P = SparteSchema.attributes;
const UN_P = UnternehmenSchema.attributes;
const FP_P = FoerderProgrammSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const PersonalKostenVN: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly, printMode } = useApplication();
	const [isZwischenmeldung, setIsZwischenmeldung] = useState(false);

	const [allFoerderProgramms, setAllFoerderProgramm] = useState([]);
	const [allSparte, setAllSparte] = useState([]);
	const [allGrundSchule, setAllGrundSchule] = useState([]);

	const groupedData = getGroupedData(application);
	const shouldUseVerticalPrintLayout = printMode && columnsLabelForPrint(readOnly, isZwischenmeldung).length > MAX_COLUMNS_HORIZONTAL_LAYOUT;

	const [tableScrollLeft, setTableScrollLeft] = useState(0);
	const tableRefs = useRef<Record<string, HTMLDivElement | null>>({});

	// ERSTMAL NUR DEAKTIVIEREN.
	// VDMK KLÄRT NOCH INTERN, OB LÖSCHEN GEBRAUCHT WIRD
	// const handleAddPersonalKosten = async () => {
	// 	try {
	// 		let appCopy = cloneDeep(application);
	// 		const UID = generateUniqueId();
	// 		const gruppierungID = generateUniqueId();

	// 		const index = get(appCopy, VN_P.Verwendungsnachweis_Nachweispositions.path, []).length;

	// 		const data = {
	// 			[getFieldNamefromDataPath(NP_P.Verwendungsnachweis.path)]: get(appCopy, 'id'),
	// 			[getFieldNamefromDataPath(NP_P.Allgemein_Kostenart.path)]: KOSTEN_ARTEN.Personalkosten,
	// 			[getFieldNamefromDataPath(NP_P.Allgemein_Position_ID.path)]: UID,
	// 			[getFieldNamefromDataPath(NP_P.Allgemein_Gruppierung_ID.path)]: gruppierungID,
	// 		};

	// 		set(appCopy, addIndexesToPath(VN_P.Verwendungsnachweis_Nachweispositions.path, [`${index}`], ['Verwendungsnachweis_Nachweispositions']), {
	// 			attributes: data,
	// 		});
	// 		saveApplication(false, appCopy);
	// 	} catch (err: any) {
	// 		console.error('ERROR: Creating Personal-Kostenposition ', err);
	// 	}
	// };
	// const handleAddEinzelPosition = async (gruppierungID: string) => {
	// 	try {
	// 		let appCopy = cloneDeep(application);
	// 		const index = get(appCopy, VN_P.Verwendungsnachweis_Nachweispositions.path, []).length;
	// 		const UID = generateUniqueId();
	// 		const data = {
	// 			[getFieldNamefromDataPath(NP_P.Verwendungsnachweis.path)]: get(appCopy, 'id'),
	// 			[getFieldNamefromDataPath(NP_P.Allgemein_Kostenart.path)]: KOSTEN_ARTEN.Personalkosten,
	// 			[getFieldNamefromDataPath(NP_P.Allgemein_Position_ID.path)]: UID,
	// 			[getFieldNamefromDataPath(NP_P.Allgemein_Gruppierung_ID.path)]: gruppierungID,
	// 			[getFieldNamefromDataPath(NP_P.Foerderprogramm.path)]: null,
	// 		};
	// 		set(appCopy, addIndexesToPath(VN_P.Verwendungsnachweis_Nachweispositions.path, [`${index}`], ['Verwendungsnachweis_Nachweispositions']), {
	// 			attributes: data,
	// 		});
	// 		saveApplication(false, appCopy);
	// 	} catch (err: any) {
	// 		console.error('ERROR: Creating Personal-Kostenposition Einzel ', err);
	// 	}
	// };
	// const handleDeleteEinzelPosition = async (gruppierungID: string) => {
	// 	try {
	// 		let appCopy = cloneDeep(application);
	// 		const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);
	// 		let filteredPositionNachID = allKostenPositions.filter((ele: any) => get(ele, NP_P.Allgemein_Gruppierung_ID.path, '') === gruppierungID);

	// 		if (isArray(filteredPositionNachID) && filteredPositionNachID.length > 0) {
	// 			const lastPosition_ID = get(filteredPositionNachID[filteredPositionNachID.length - 1], 'id', -1);
	// 			if (lastPosition_ID) {
	// 				let res = await DeleteRecord(APIS.Kostenposition, lastPosition_ID);
	// 				if (res) {
	// 					const newPositionForApp_ARR = allKostenPositions.filter((ele: any) => get(ele, 'id') !== lastPosition_ID);
	// 					set(appCopy, VN_P.Verwendungsnachweis_Nachweispositions.path, newPositionForApp_ARR);
	// 					saveApplication(false, appCopy);
	// 				}
	// 			}
	// 		}
	// 	} catch (err: any) {
	// 		console.error('ERROR: Deleting Einzel Personalkosten ', err);
	// 	}
	// };

	useEffect(() => {
		let nachweisType = get(application, VN_P.Allgemein_Nachweistyp.path, '').trim();
		if (nachweisType === ANTRAG_TYP.Zwischenmeldung) setIsZwischenmeldung(true);

		const fetch = async () => {
			try {
				let programmRes = await GetRecords(APIS.FörderProgramme);
				let sparteRes = await GetRecords(APIS.Sparte, [getFieldNamefromDataPath(SP_P.Foerderprogramm.path)]);
				const schuleFilter = {
					// [getFieldNamefromDataPath(UN_P.Geschaeftsbezogene_Daten_Rolle.path)]: UNTERNEHMENS_ROLLE.Grundschlue,
					[getFieldNamefromDataPath(UN_P.MKS.path)]: get(application, `${VN_P.Antrag.schema.attributes.MKS.path}.id`),
				};
				let schuleRes = await GetRecords(APIS.Organisation, [], schuleFilter);
				if (programmRes) setAllFoerderProgramm(removeDataKeys(removeNullDeep(get(programmRes, 'data', []))));
				if (sparteRes) setAllSparte(removeDataKeys(removeNullDeep(get(sparteRes, 'data', []))));
				if (schuleRes) setAllGrundSchule(removeDataKeys(removeNullDeep(get(schuleRes, 'data', []))));
			} catch (err: any) {
				console.error('ERROR: Fetcching Förderprogramme ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		// Get all Kostenpositions
		const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);
		allKostenPositions.forEach((item: any, idx: number) => {
			// Only for Personalkosten
			if (get(item, NP_P.Allgemein_Kostenart.path, '') === KOSTEN_ARTEN.Personalkosten) {
				// Build the path to the field for this index
				const path = `${VN_P.Verwendungsnachweis_Nachweispositions.path}.${idx}.${NP_P.Tatsaechliche_Foerderung_Tatsaechliche_U_Std.path}`;
				// Set the value to 0 if not already set
				if (get(application, path) === undefined) {
					setApplicationProperty(path, 0);
				}
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ApplicationHeading title='Kosten' description={PLATZHALTER_TEXT} />
			<Stack direction={{ xs: 'column', md: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
				{/* <Button onClick={() => handleAddPersonalKosten()} endIcon={<AddIcon />} disabled={readOnly}>
					Personalkosten hinzufügen
				</Button> */}
			</Stack>

			{/* eslint-disable-next-line array-callback-return */}
			{Object.keys(groupedData).map((gruppierungID: any, index: number) => {
				if (gruppierungID !== undefined) {
					return (
						<Box
							key={`${gruppierungID + index}`}
							sx={{
								mt: '1rem',
								...(printMode ?
									shouldUseVerticalPrintLayout ?
										index === 0 ?
											{ border: 'none', breakInside: 'auto', pageBreakInside: 'auto' }
										:	{ border: 'none', breakInside: 'avoid-page', pageBreakInside: 'avoid' }
									:	{ border: 'none', breakInside: 'avoid-page', pageBreakInside: 'avoid' }
								:	{ border: '2px solid' }),
								padding: '1rem',
							}}
						>
							<Box
								sx={
									printMode && shouldUseVerticalPrintLayout ?
										index === 0 ?
											{ breakInside: 'auto', pageBreakInside: 'auto' }
										:	{ breakInside: 'avoid-page', pageBreakInside: 'avoid' }
									:	{}
								}
							>
								{printMode && (
									<Typography variant='body2' sx={{ mb: 1, fontWeight: 'bold' }}>
										Förderprogramm
									</Typography>
								)}
								<CreateForm
									formStruc={formStruc(application, gruppierungID, allFoerderProgramms)}
									formValues={application}
									updateFormValuesFunc={setApplicationProperty}
									readOnly={readOnly}
									api={APIS.Kostenposition}
									printMode={printMode}
								/>
								<CreateTable
									ref={(el: HTMLDivElement | null) => {
										(tableRefs.current as Record<string, HTMLDivElement | null>)[gruppierungID] = el;
									}}
									formStruc={formStrucTabelle(application, readOnly, gruppierungID, allSparte, allGrundSchule, isZwischenmeldung, readOnly)}
									formValues={application}
									updateFormValuesFunc={setApplicationProperty}
									readOnly={readOnly}
									api={APIS.Kostenposition}
									columnsLabel={printMode ? columnsLabelForPrint(readOnly, isZwischenmeldung) : columnsLabel(readOnly, isZwischenmeldung)}
									tableScrollLeft={tableScrollLeft}
									setTableScrollLeft={setTableScrollLeft as React.Dispatch<React.SetStateAction<number>>}
									printMode={printMode}
								/>
							</Box>
							{/* <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'center'} spacing={2}>
								<Button onClick={() => handleAddEinzelPosition(gruppierungID)} endIcon={<AddIcon />} disabled={readOnly}>
									Einzelposition hinzufügen
								</Button>
							<Button onClick={() => handleDeleteEinzelPosition(gruppierungID)} endIcon={<Delete />} disabled={readOnly}>
									Letzte Position löschen
								</Button> 
							</Stack> */}
						</Box>
					);
				}
			})}
		</>
	);
};

export default PersonalKostenVN;

const formStruc = (application: any, gruppierungID: string, allFoerderProgramms?: any[]) => {
	let struc: FormStrucItem[] = [];
	const allFoerderProgrammsOptions = allFoerderProgramms || [];
	const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

	let foundOneElement: boolean = false;
	for (let i = 0; i < allKostenPositions.length; i++) {
		const eachKostenPosition = allKostenPositions[i];

		if (!foundOneElement) {
			if (get(eachKostenPosition, NP_P.Allgemein_Gruppierung_ID.path) === gruppierungID) {
				foundOneElement = true;
				struc = [
					...mapKosten(
						[
							{
								fields: [
									{
										...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Foerderprogramm,
										type: FORM_FIELDS_TYPES.singleSelect,
										options: getOptionsFromRes(allFoerderProgrammsOptions, getFieldNamefromDataPath(FP_P.Allgemein_Titel.path)),
										disabled: true,
										label: 'Förderprogramm',
									},
								],
							},
						],
						i,
					),
				];
			}
		}
	}

	return struc;
};

const columnsLabel = (readOnly: boolean, isZwischenmeldung: boolean) => {
	let labels = [
		{ label: 'Schule', width: '24rem', maxWidth: '24rem' },
		{ label: 'Sparte' },
		{ label: 'Lehrkraft', width: '24rem', maxWidth: '24rem' },
		{ label: 'Anstellung', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },

		// klassen, ustd/woche, UWo if not zwischenmeldung
		// Bewilligte UStd., Tatsächliche UStd.,Prognostizierte UStd.,Minderstunden if zwischenmeldung
		...(!isZwischenmeldung ?
			[
				{ label: 'Bewilligte UStd.', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
				{ label: 'Tatsächliche UStd.', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
				// { label: 'Anerkannte UStd.', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
				// { label: 'Minderstunden', maxWidth: '8rem', minWidth: '6rem', width: '6rem' }
			]
		:	[
				{ label: 'Bewilligte UStd.', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
				{ label: 'Tatsächliche UStd. vor ZM', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
				{ label: 'Prognostizierte UStd. nach ZM', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
				{ label: 'Minderstunden', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
			]),
		{ label: 'Honorarsatz (€)', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
		{ label: 'Bewilligte Sachkosten', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
		{ label: 'Tatsächliche Sachkosten', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
		{ label: 'Tatsächliche Förderung' },
	];

	if (readOnly) labels.push({ label: 'bewilligte Förderung' });

	return labels;
};

const columnsLabelForPrint = (readOnly: boolean, isZwischenmeldung: boolean) => {
	let labels = [
		{ label: 'Schule', width: '11rem', maxWidth: '11rem' },
		{ label: 'Sparte', width: '8rem', maxWidth: '8rem' },
		{ label: 'Lehrkraft', width: '7rem', maxWidth: '7rem' },
		{ label: 'Anstellung', width: '4rem', maxWidth: '4rem' },

		// klassen, ustd/woche, UWo if not zwischenmeldung
		// Bewilligte UStd., Tatsächliche UStd.,Prognostizierte UStd.,Minderstunden if zwischenmeldung
		...(!isZwischenmeldung ?
			[
				{ label: 'Bewilligte UStd.', maxWidth: '4rem', minWidth: '4rem', width: '4rem' },
				{ label: 'Tatsächliche UStd.', maxWidth: '4rem', minWidth: '4rem', width: '4rem' },
				// { label: 'Anerkannte UStd.', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
				// { label: 'Minderstunden', maxWidth: '8rem', minWidth: '6rem', width: '6rem' }
			]
		:	[
				{ label: 'Bewilligte UStd.', maxWidth: '6rem', minWidth: '6rem', width: '6rem' },
				{ label: 'Tatsächliche UStd. vor ZM', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
				{ label: 'Prognostizierte UStd. nach ZM', maxWidth: '8rem', minWidth: '8rem', width: '8rem' },
				{ label: 'Minderstunden', maxWidth: '8rem', minWidth: '6rem', width: '6rem' },
			]),
		{ label: 'Honorarsatz (€)', maxWidth: '4rem', minWidth: '4rem', width: '4rem' },
		{ label: 'Bewilligte Sachkosten', maxWidth: '6rem', minWidth: '6rem', width: '6rem' },
		{ label: 'Tatsächliche Sachkosten', maxWidth: '6rem', minWidth: '6rem', width: '6rem' },
		{ label: 'Tatsächliche Förderung' },
	];

	if (readOnly) labels.push({ label: 'bewilligte Förderung' });

	return labels;
};

const formStrucTabelle = (
	application: any,
	readOnly: boolean,
	gruppierungID: string,
	allSparte?: any[],
	allGrundSchule?: any[],
	isZwischenmeldung?: boolean,
	readonly?: boolean,
) => {
	let struc: FormStrucItem[] = [];
	const allSparteOption = allSparte || [];
	const allGrundSchuleOption = allGrundSchule || [];
	const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

	for (let i = 0; i < allKostenPositions.length; i++) {
		const eachPosition = allKostenPositions[i];
		let tempStruc: FormStrucItem[] = [];
		const selectedSparteID = getIDFromResponseOption(get(eachPosition, NP_P.Sparte.path));
		const selectedSparte = find(allSparteOption, (sp: any) => get(sp, 'id') === selectedSparteID);
		const sparteSachkostenErlaubt = get(selectedSparte, 'attributes.Allgemein_Sachkosten_Erlaubt', false);
		const sachkostenErlaubt = sparteSachkostenErlaubt;

		if (
			get(eachPosition, NP_P.Allgemein_Gruppierung_ID.path, '') === gruppierungID &&
			get(eachPosition, NP_P.Allgemein_Kostenart.path, '') === KOSTEN_ARTEN.Personalkosten
		) {
			const selectedProgrammID = getIDFromResponseOption(get(eachPosition, NP_P.Foerderprogramm.path));
			const sparteOption_Filtered = allSparteOption.filter((ele: any) => get(ele, `${SP_P.Foerderprogramm.path}.id`) === selectedProgrammID);

			tempStruc.push({
				fields: [
					{
						...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Schule,
						type: FORM_FIELDS_TYPES.singleSelect,
						options: getOptionsFromRes(
							allGrundSchuleOption,
							getFieldNamefromDataPath(UN_P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path),
						),
						disabled: true,
					},
					{
						...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Sparte,
						type: FORM_FIELDS_TYPES.singleSelect,
						options: getOptionsFromRes(sparteOption_Filtered, getFieldNamefromDataPath(SP_P.Allgemein_Bezeichnung.path)),
						disabled: true,
					},
					{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Lehrkraft_MKS },

					...(!isZwischenmeldung ?
						[
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Anstellung },
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Bewilligte_U_Std, disabled: true },
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Tatsaechliche_U_Std },
							// { ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Anerkannte_U_Std, disabled: true },
							// { ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Minderstunden, disabled: true },
						]
					:	[
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Anstellung },
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Bewilligte_U_Std, disabled: true },
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Tatsaechliche_U_Std },
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Prognostizierte_U_Std, default: 0 },
							{ ...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Minderstunden, disabled: true },
						]),
					{
						...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Honorarsatz,
						format: 'currency',
						disabled: true,
					},
					{
						...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Bewilligte_Foerderung_Sachkosten,
						format: 'currency',
						disabled: true,
					},
					{
						...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Tatsaechliche_Sachkosten,
						format: 'currency',
						disabled: !sachkostenErlaubt || readonly,
					},
					{
						...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Tatsaechliche_Foerderung_Tatsaechliche_Foerderung,
						format: 'currency',
						disabled: true,
					},
					...(readOnly ?
						[
							{
								...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Bewilligte_Foerderung_Bewilligte_Foerderung,
								format: 'currency',
								disabled: true,
							},
						]
					:	[]),
				],
			});

			struc.push(...mapKosten(tempStruc, i));
		}
	}

	return struc;
};

const mapKosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, VN_P.Verwendungsnachweis_Nachweispositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(VN_P.Verwendungsnachweis_Nachweispositions.path.length),
				};
			}),
		};
	});
	return result;
};

const getGroupedData = (application: any) => {
	const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);
	// eslint-disable-next-line array-callback-return
	const groupedData = allKostenPositions.reduce((acc: any, item: any) => {
		const key = get(item, NP_P.Allgemein_Gruppierung_ID.path, '').trim();

		if (get(item, NP_P.Allgemein_Kostenart.path, '') === KOSTEN_ARTEN.Personalkosten) {
			if (key) {
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
			}
		}
		return acc;
	}, {});
	return groupedData;
};

export const getFormStrucPersonalKostenVN = (application: any) => {
	return concat(formStruc(application, ''));
};
